export default __webpack_public_path__ + "images/Vegetarian.57f125.jpg";